/*
MobileSiderDrawer.js
移动端侧边栏
 */

import React, {useState} from 'react';
import {Button, Drawer} from "antd";
import {CloseOutlined} from "@ant-design/icons";

import {Point5FullSVG} from "../../../Common/PointFive/Point5FullIcon_Dark";
import SiderMenu from "../SiderMenu";

const MobileSiderDrawer = ({drawerOnClose, isDrawerOpen, handleChangeSession}) => {

    return (
        <Drawer title={<Point5FullSVG style={{ height: '4vh', width: 'auto' }}/>}
                placement='left' width='100vw' size='large' open={isDrawerOpen} closeIcon={null}
                extra={<Button type='text' icon={<CloseOutlined style={{color: '#808080'}}/>} size='large'
                               onClick={drawerOnClose}/>}>
            <SiderMenu isMobile={true} drawerOnClose={drawerOnClose} isDrawerOpen={isDrawerOpen} handleChangeSession={handleChangeSession}/>
        </Drawer>
    );
};

export default MobileSiderDrawer;